import useQuery from '../../../util/useQuery';
import CustomizeForm from './DsRequest/CustomizeForm';
import CustomizeStyle from './DsRequest/CustomizeStyle';
import CustomizeRights from './Rights';
import CustomizeContent from './ThankYou/CustomizeContent';

const Customize = ({ form, initialValue, requestType }) => {
    const params = useQuery();
    const tab = params.get('tab') || '1';

    let content;
    if (tab === '1') {
        content = (
            <>
                <CustomizeForm
                    requestType={requestType}
                    form={form}
                    initialValue={initialValue}
                />
                <CustomizeStyle form={form} initialValue={initialValue} />
            </>
        );
    } else if (tab === '2') {
        content = <CustomizeRights requestType={requestType} form={form} />;
    } else {
        content = <CustomizeContent form={form} />;
    }

    return (
        <div className="bg-white p-4 mt-4 rounded-md col-span-1 space-y-4 h-max">
            {content}
        </div>
    );
};

export default Customize;
